const pageNameKey = "drawerIconContainer";

export const drawerIconContainerEn = {
  [pageNameKey]: {
    altText: "drawer-icon",
  },
};

export const drawerIconContainerPtBr = {
  [pageNameKey]: {
    altText: "ícone da gaveta",
  },
};

export const drawerIconContainerDe = {
  [pageNameKey]: {
    altText: "Drawer-Icon",
  },
};

export const drawerIconContainerZhHans = {
  [pageNameKey]: {
    altText: "抽屉图标",
  },
};

export const drawerIconContainerIt = {
  [pageNameKey]: {
    altText: "Icona drawer",
  },
};

export const drawerIconContainerEs = {
  [pageNameKey]: {
    altText: "icono del cajón",
  },
};

export const drawerIconContainerNl = {
  [pageNameKey]: {
    altText: "lade-pictogram",
  },
};

export const drawerIconContainerTr = {
  [pageNameKey]: {
    altText: "çekmece simgesi",
  },
};
